import { Pipe, PipeTransform, SecurityContext } from '@angular/core';
import { DomSanitizer, SafeResourceUrl } from '@angular/platform-browser';

@Pipe({ name: 'htmlToText' })
export class HtmlToTextPipe implements PipeTransform {
  transform(value: string): string {
    return value
      ? value
        .replace(/&nbsp;/gi, ' ')
        .replace(/&amp;/gi, ' ')
        .replace(/&lsquo;/gi, '\'')
        .replace(/&rsquo;/gi, '\'')
        .replace(/&quot;/gi, '"')
        .replace(/&ldquo;/gi, '"')
        .replace(/&rdquo;/gi, '"')
        .replace(/&aacute;/g, 'a')
        .replace(/&Aacute;/g, 'A')
        .replace(/&eacute;/g, 'e')
        .replace(/&Eacute;/g, 'E')
        .replace(/&iacute;/g, 'i')
        .replace(/&Iacute;/g, 'I')
        .replace(/&oacute;/g, 'o')
        .replace(/&Oacute;/g, 'O')
        .replace(/&uacute;/g, 'u')
        .replace(/&Uacute;/g, 'U')
        .replace(/&yacute;/g, 'y')
        .replace(/&Yacute;/g, 'Y')
        .replace(/&lacute;/g, 'l')
        .replace(/&Lacute;/g, 'L')
        .replace(/<[^>]*>?/gm, '')
      : '';
  }
}
